import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTimeDTO } from 'src/app/model/date-time-dto.model';
import { DateTimeHelper } from 'src/app/model/helpers/date-time/date-time.helper';

@Component({
    selector: 'edl-modal-datepicker',
    templateUrl: './edl-modal-date-picker.component.html',
    styleUrls: ['./edl-modal-date-picker.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EdlModalDatePickerComponent implements OnInit {
    @Input() title: string = '';
    @Input() label: string = '';
    @Input() dateTime?: DateTimeDTO;

    form!: FormGroup;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            datePicker: [DateTimeHelper.toDate(this.dateTime), [Validators.required]],
            timePicker: [DateTimeHelper.toDate(this.dateTime), [Validators.required]]
        });
    }

    submit({ value, valid }: { value: { datePicker: Date, timePicker: Date }, valid: boolean }) {
        if (valid) {
            const dateTime = DateTimeHelper.toDateTimeDTO(value.datePicker, value.timePicker)
            this.activeModal.close(dateTime);
        }
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
